export default __webpack_public_path__ + "static/media/restore-icon.0691ecd5.svg";